import ApeironComponent from '@/components/commons/apeiron-component.model';
import { ActividadRetribucion, IndicadoresRetribucion, MenuGenerico } from '@/shared/model/ars/ars.model';
import CatalogosArs from '@/shared/model/ars/catalogos-ars.factory';
import { Solicitud } from '@/shared/model/solicitud.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { maxLength, minValue, required } from 'vuelidate/lib/validators';

const validations = function () {
  return {
    indicadoresForm: {
      numeroActividades: { required, minValue: minValue(0) },
      horasDedicadas: { required, minValue: minValue(0) },
      institucionesParticipantes: { required, minValue: minValue(0) },
      comunidadesAtendidas: { required, minValue: minValue(0) },
      impactoPercibido: { required, maxLength: maxLength(500) },
      resultadosObservables: { required, maxLength: maxLength(500) },
      puedeReplicarse: { required },
      puedeReplicarseDesc: { maxLength: maxLength(500) },
    },
  };
};
@Component({
  validations,
})
export default class ActividadIndicadoresArsComponent extends ApeironComponent {
  @Prop({ required: true })
  public readonly solucion!: Solucion;

  @Prop({ required: true })
  public readonly solicitud!: Solicitud;

  @Prop({ required: true })
  public permisos: any;

  public indicadoresForm: IndicadoresRetribucion = new IndicadoresRetribucion();

  public opcionesContribuciones: Array<MenuGenerico> = [];
  public opcionesReplicable: Array<MenuGenerico> = [];

  public mounted(): void {
    this.opcionesContribuciones =
      CatalogosArs.obtenerContribuciones().map(contribucion => new MenuGenerico(contribucion.descripcion, contribucion)) ?? [];
    this.opcionesReplicable =
      CatalogosArs.obtenerOpcionesReplicable().map(replicable => new MenuGenerico(replicable.descripcion, replicable)) ?? [];
    if (this.solicitud.indicadoresRetribucion) {
      this.indicadoresForm = IndicadoresRetribucion.fromObject(this.solicitud.indicadoresRetribucion);
    }
  }

  public guardarIndicadores(): void {
    this.$emit('submit', { indicadoresRetribucion: this.indicadoresForm });
  }

  @Emit('changed-navegation')
  public emitirGuardado(actividadGuardada: ActividadRetribucion): ActividadRetribucion {
    return actividadGuardada;
  }

  get esReadOnly(): boolean {
    return this.readOnly;
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }

  get desactivarBoton(): boolean {
    return this.$v.$invalid;
  }
}
